import en from "@/localization/en.json";
import { PropTypes } from "prop-types";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { PrevLabelIcon, NextLabelIcon } from "../data-display/Icon";
import PaginationBtn from "../action/button/PaginationBtn";

export default function Pagination({
  total = 1,
  currentPage,
  getPaginateData,
}) {
  const [pageWidth, setPageWidth] = useState("");
  const [pageRange, setPageRange] = useState(5);

  const [activePage, setActivePage] = useState(() =>
    currentPage ? currentPage : 0
  );

  useEffect(() => {
    const handleResize = () => {
      setPageWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    setPageWidth(window.innerWidth);

    calculatePageRange();
  }, [pageWidth]);

  useEffect(() => {
    setActivePage(currentPage);
  }, [currentPage]);

  // calculate display paginate element for mobile end
  const calculatePageRange = () => {
    if (pageWidth <= 640) {
      setPageRange(2);
    } else {
      setPageRange(5);
    }
  };

  const handlePageChange = (event) => {
    getPaginateData(event.selected);
    setActivePage(event.selected);
  };

  return (
    <div>
      <ReactPaginate
        previousLabel={
          <PaginationBtn isDisable={activePage === 0}>
            <>
              <PrevLabelIcon isDisable={activePage === 0} />
              <span className="text-[1rem] ml-[0.75rem]">
                {en["common.previous"]}
              </span>
            </>
          </PaginationBtn>
        }
        nextLabel={
          <PaginationBtn isDisable={activePage === total - 1}>
            <>
              <span className="text-[1rem] mr-[0.75rem]">
                {en["common.next"]}
              </span>
              <NextLabelIcon isDisable={activePage === total - 1} />
            </>
          </PaginationBtn>
        }
        pageRangeDisplayed={pageRange}
        marginPagesDisplayed={1}
        pageCount={total}
        onPageChange={handlePageChange}
        className="flex justify-center items-center my-8"
        pageClassName="h-[2.25rem] w-[2.25rem] rounded-full  flex items-center justify-center"
        activeClassName="bg-darkPrimary text-white"
        previousClassName=" mr-[2.5rem] text-grayD1"
        nextClassName="ml-[2.5rem] text-grayD1"
        forcePage={activePage}
      />
    </div>
  );
}

Pagination.propTypes = {
  total: PropTypes.number,
  currentPage: PropTypes.number,
  getPaginateData: PropTypes.func,
};
